export function emailErrorFeedback(error) {
  if (error.response?.status === 413) return { field: "attachments", message: "Attachments are too large. Keep the total at 5 MB or less and try again." };
  const field = error.response?.data?.Result_Error?.field;
  const message = error.response?.data?.Result_Message || error.message || "Email could not be sent. Please try again.";
  return {
    field: ["recipient", "attachments"].includes(field) ? field : "delivery",
    message: !error.response && (error.code === "ERR_NETWORK" || error.request)
      ? "The server could not be reached. Check your connection and try again."
      : message,
  };
}

export default function NoteEmailError({ error, field }) {
  return error?.field === field
    ? <p role="alert" className="note-email-field-error">{error.message}</p>
    : null;
}
